import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import EnquiryForm from "./EnquiryForm";
import { Spinner, Alert } from "react-bootstrap";

const EditEnquiryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    const fetchEnquiry = async () => {
      setLoading(true);
      setErr("");
      try {
        const { data } = await apiClient.get(`/enquiries/${id}`);
        setForm({ ...data.enquiry });
      } catch {
        setErr("Failed to load enquiry details.");
      }
      setLoading(false);
    };
    fetchEnquiry();
  }, [id]);

  if (loading) return <div className="text-center my-5"><Spinner /></div>;
  if (err) return <Alert variant="danger" className="my-5 text-center">{err}</Alert>;

  return (
    <EnquiryForm
      mode="edit"
      initialData={form}
      title="Edit Enquiry"
      subtitle="Update enquiry details"
      onCancel={() => navigate(-1)}
      onSubmitSuccess={() => navigate("/enquiries")}
    />
  );
};

export default EditEnquiryPage;
